export default "__VITE_ASSET__Ct9zcmnH__"